export default function () {
  const widgetName = 'CardWidget';
  const { currentWidgetModuleItemID, scriptPath } = CardWidgetOpts;
  const breakpoint = 800;
  const isDesktopScreen = $(window).width() >= breakpoint;
  const showMoreButton = true;
  const moreButtonText = 'More';
  const showBuyButton = false;
  const buyButtonText = 'Buy Now';
  const hideAllButtons = false;
  const showDescription = true;
  const titleOverImage = true;

  const buildCardStructure = (dataWidget) => {
    const description = dataWidget.Description
      ? `<span class="widget-description">${dataWidget.Description}</span>`
      : '';

    // Extracted logic for buttons
    const buttons = (() => {
      let buttonsHTML = '';
      if (dataWidget.URL && showMoreButton) {
        buttonsHTML += `<a class="button" href="${dataWidget.URL}">${moreButtonText}</a>`;
      }
      if (dataWidget.PurchaseURL && showBuyButton) {
        buttonsHTML += `<a class="button" href="${dataWidget.PurchaseURL}">${buyButtonText}</a>`;
      }
      return buttonsHTML;
    })();

    // Logic for the button container
    const buttonContainer =
      dataWidget.URL || (dataWidget.PurchaseURL && !hideAllButtons)
        ? `<div class="buttons-containers">${buttons}</div>`
        : '';

    // Extracted ternary operation
    let rolloverContent = '';
    if (isDesktopScreen && !hideAllButtons) {
      rolloverContent = `<div class="rollover-content">${showDescription ? description : ''}${buttonContainer}</div>`;
    }

    return `
      <div class="card-content">
        ${titleOverImage ? `<span class="widget-title">${dataWidget.Title}</span>` : ''}
        ${rolloverContent}
      </div>
      <div class="img-background lozad" style="background-image: url('${dataWidget.ImageWithPath}')">
        <div class="overlay"></div>
      </div>
      ${!titleOverImage ? `<span class="widget-title-outside">${dataWidget.Title}</span>` : ''}
    `;
  };

  const configureCardLink = ($card, dataWidget) => {
    if (!dataWidget.URL && !dataWidget.PurchaseURL && !dataWidget.Description) {
      $card.addClass('void-link').removeAttr('href');
    } else {
      $card.removeClass('void-link').removeAttr('target');
      if (!isDesktopScreen && dataWidget.PurchaseURL) {
        $card.attr('href', dataWidget.PurchaseURL);
      }
    }
  };

  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    currentWidgetModuleItemID,
    link: isDesktopScreen ? [] : ['all'],
    maxItemsVisible: 8,
    itemsPerPanel: 8,
    lazyLoadImages: true,
    scriptPath,
    cardWidgetLoaded: function (data) {
      if (!data.items.length) return $(`#${widgetName}`).remove();
      $(`#${widgetName}`).addClass(`cards-${data.items.length}`);
      $(`#${widgetName} .card-widget-item`).each((index, element) => {
        const $card = $(element);
        const dataWidget = data.items[index];
        $card.empty().append(buildCardStructure(dataWidget));
        configureCardLink($card, dataWidget);
      });
      if (!titleOverImage) {
        $(`#${widgetName} .card-widget-item`).addClass('title-outside');
      }
    },
  });
}
